module.exports = __webpack_public_path__ + "static/media/BodoniFLF-Bold.371e8c3f.ttf";